import config from '../config'
import Core from 'aws-sdk/lib/core'
import AWS from 'aws-sdk'

export function _fetch(method, path, query, file, onprogress) {
  AWS.config.update({
    accessKeyId: config.aws.accessKeyId,
    secretAccessKey: config.aws.secretAccessKey,
    region: config.aws.region
  });

  var body = ''
  if (query) {
    switch(method) {
      case 'POST':
        if(query){
          body = query.replace(/<a href=".*?".*?>.*?<\/a>/g, '')
                      .replace(/<[^>]*?>/g, '')
                      .replace(/ ?:emoji-([-0-9a-f]+): ?/ig,'')
                      .replace(/(https?:\/\/[^\s]+)/g, '')
                      .replace(/\s/g, '')
        }
    }
  }
  const data = JSON.stringify({
    user_message: body
  })
  const httpRequest = new AWS.HttpRequest(`${config.aws.lambdaEndpoint}${path}`, AWS.config.region);
  httpRequest.method = method;
  httpRequest.headers['host'] = 'tisfiy6gkzs4oobyfaqnkw7t740isdfk.lambda-url.ap-northeast-1.on.aws';
  httpRequest.headers['content-type'] = 'application/json';
  httpRequest.headers['accept'] = 'text/event-stream';
  httpRequest.headers['Lambda-Runtime-Function-Response-Mode'] = 'streaming';
  httpRequest.body = data;
  return fetch(httpRequest.endpoint.href, {
    method: httpRequest.method,
    headers: httpRequest.headers,
    body: httpRequest.body
  })
}

export default {
  get: function (path, query = null) {
    return _fetch('GET', path, query, null)
  },

  post: function (path, query = null) {
    return _fetch('POST', path, query, null)
  },

  put: function (path, query = null) {
    return _fetch('PUT', path, query, null)
  },

  delete: function (path, query = null) {
    return _fetch('DELETE', path, query, null)
  },
}


// WEBPACK FOOTER //
// ./src/actions/lambda-api.js